import { cloneDeep } from 'lodash-es';
import moment from 'moment';

import * as SearchActions from '../../../../state/search/search.action';

import template from './s-equipment-update.html';

class EquipmentUpdateController {
  constructor(
    $ngRedux,
    $scope,
    $state,
    $filter,
    $stateParams,
    $timeout,
    EquipmentService,
    gettextCatalog,
    tagsService,
  ) {
    'ngInject';

    this.$scope = $scope;
    this.$state = $state;
    this.$filter = $filter;
    this.$stateParams = $stateParams;
    this.timeout = $timeout;
    this.EquipmentService = EquipmentService;
    this.gettextCatalog = gettextCatalog;
    this.store = $ngRedux;
    this.tagsService = tagsService;

    this.tags = [];
    this.isLoading = true;
    this.selectedTags = [];
    this.parsedAttrs = {};
    this.parsedTags = [];
    this.values = {};
    this.focus = {};
    this.opened = {};
    this.datetimedate = {};
    this.datetimeBounds = {};
    this.protectedAttrs = {};

    this.mapStateToThis = this.mapStateToThis.bind(this);
    this.initDataNeeded = true;
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, SearchActions)(this);
    this.refreshEdit();
  }

  mapStateToThis(state) {
    const { attributes } = state;

    const { secured = {}, isSecuredLoaded, items } = attributes;
    // when secured.readonly loaded after init
    // call refreshEdit() for one time only
    if (isSecuredLoaded && this.initDataNeeded) {
      this.refreshEdit();
    }

    return {
      // secured.readonly: been normalized to lowercase keys
      readonlyAttributes: secured.readonly,
      readonlyAttributesLoaded: isSecuredLoaded,
      tags: items,
    };
  }

  $onDestroy() {
    this.unsubscribe();
  }

  refreshEdit() {
    this.isLoading = true;

    // if readonlyAttributesLoaded has not loaded will return now, another call will trigger by mapStateToThis
    if (!this.readonlyAttributesLoaded) return;

    this.initDataNeeded = false;
    this.assetName = this.asset.name;

    if (this.asset.attrs) {
      this.parseTags();
    }

    this.availableTags = cloneDeep(this.tags);
    this.selectedTags = [];
    this.values = {};

    for (let i = 0; i < this.parsedTags.length; i++) {
      const parsedTag = this.parsedTags[i];
      const parsedTagIndex = parsedTag.index;
      const parsedTagValue = parsedTag.value;
      const parsedTagId = parsedTag.id;
      const availableTag = this.availableTags[parsedTagIndex];
      // appandtag set this.values.
      this.appendTag(availableTag, false);

      const parsedTagValueRecord = this.values[parsedTagId];
      const { dataType } = availableTag;

      switch (dataType) {
        case 'Integer': {
          parsedTagValueRecord.value = parseInt(parsedTagValue);
          break;
        }

        case 'Decimal': {
          parsedTagValueRecord.value = parseFloat(parsedTagValue);
          break;
        }

        case 'Text': {
          parsedTagValueRecord.value = parsedTagValue;
          break;
        }

        case 'Date': {
          parsedTagValueRecord.value = moment(parsedTagValue).toDate();
          break;
        }

        case 'Datetime': {
          const parsedDate = moment(parsedTagValue).toDate();
          parsedTagValueRecord.value = parsedDate;
          this.datetimedate[parsedTagId] = parsedDate;
          break;
        }

        default:
          parsedTagValueRecord.value = parsedTag.value;
      }
      // re assign handled record.
      this.values[parsedTagId] = parsedTagValueRecord;
    }

    this.isLoading = false;
  }

  parseTags() {
    this.parsedTags = [];
    this.parsedAttrs = {};
    for (const key in this.asset.attrs) {
      const normalizedKey = key != null ? key.toLowerCase() : '';
      const attrValue = this.asset.attrs[key] || null;
      if (this.readonlyAttributes.indexOf(normalizedKey) !== -1) {
        // readonly attributes are hidden completely from this UI
        this.protectedAttrs[key] = this.asset.attrs[key];
        continue;
      } else if (key.startsWith('onei3:')) {
        this.protectedAttrs[key] = this.asset.attrs[key];
        continue;
      } else if (attrValue === null) continue;

      let found = false;
      for (let j = 0; j < this.tags.length; j++) {
        const tag = this.tags[j];
        if (normalizedKey === tag.key.toLowerCase()) {
          this.parsedTags.push({
            key: tag.key,
            value:
              tag.dataType === 'Datetime' ? moment(this.asset.attrs[key]) : this.asset.attrs[key],
            index: j,
            dataType: tag.dataType,
            id: tag.id,
          });
          found = true;
          break;
        }
      }
      if (!found) {
        this.parsedAttrs[key] = this.asset.attrs[key];
      }
    }
  }

  appendTag(tag, isNew) {
    this.selectedTags.push(tag);
    this.values[tag.id] = {
      tag: tag.id,
    };
    if (tag.dataType === 'Date' || tag.dataType === 'Datetime') {
      this.opened[tag.id] = false;
      if (tag.freeform) {
        this.values[tag.id].value = moment().toDate();
        if (tag.dataType === 'Datetime') {
          this.values[tag.id].value = moment().toDate();
          this.datetimedate[tag.id] = moment(this.values[tag.id].value).toDate();
          this.datetimeBounds[tag.id] = {};
        }
      } else {
        if (tag.range.min) {
          this.values[tag.id].value = moment(tag.range.min).toDate();
          if (tag.dataType === 'Datetime') {
            this.values[tag.id].value = moment(tag.range.min).toDate();
            this.datetimedate[tag.id] = moment(tag.range.min).toDate();
            this.values[tag.id].minValue = moment(tag.range.min).toDate();
            this.datetimeBounds[tag.id] = {};
          }
        }
        if (tag.range.max) {
          this.values[tag.id].value = moment(tag.range.max).toDate();
          if (tag.dataType === 'Datetime') {
            this.values[tag.id].value = moment(tag.range.max).toDate();
            this.datetimedate[tag.id] = moment(tag.range.max).toDate();
            this.values[tag.id].maxValue = moment(tag.range.max).toDate();
            this.datetimeBounds[tag.id] = {};
          }
        }
      }
    }
    tag.selected = true;
    this.newTag = undefined;
    this.focus[tag.id] = isNew;
  }

  removeTag(index) {
    const tag = this.selectedTags[index];
    tag.selected = false;
    if (this.asset.attrs[tag.key]) {
      delete this.asset.attrs[tag.key];
    }
    delete this.values[tag.id];
    delete this.focus[tag.id];
    this.selectedTags.splice(index, 1);
  }

  removeAttr(key) {
    delete this.parsedAttrs[key];
  }

  filterSelected(tag) {
    return !tag.selected;
  }

  roundInt(val) {
    return val ? Math.floor(val) : val;
  }

  open(index) {
    this.opened[index] = true;
  }

  getDateTime(date, time) {
    const temp = moment(date.getTime()).toDate();
    if (time) {
      temp.setHours(time.getHours());
      temp.setMinutes(time.getMinutes());
      temp.setSeconds(time.getSeconds());
    }

    temp.setMilliseconds(0);
    return temp;
  }

  datetimeValidCheck(id) {
    const valueRecord = this.values[id];
    const { value } = valueRecord;
    const temp = this.getDateTime(this.datetimedate[id], value);

    if (
      (!valueRecord.minValue || temp >= valueRecord.minValue) &&
      (!valueRecord.maxValue || temp <= valueRecord.maxValue)
    ) {
      return true;
    }

    return false;
  }

  updateTimeBounds(id) {
    this.datetimeBounds[id].min = this.returnTimeBound('min', id);
    this.datetimeBounds[id].max = this.returnTimeBound('max', id);
  }

  returnTimeBound(key, id) {
    const valueRecord = this.values[id];
    switch (key) {
      case 'max':
        if (!this.datetimedate[id] || !valueRecord.maxValue) {
          return undefined;
        }
        if (this.datetimedate[id].toDateString() === valueRecord.maxValue.toDateString()) {
          const tempMax = this.getDateTime(valueRecord.value, valueRecord.maxValue);
          return tempMax;
        }
        return undefined;

      case 'min':
        if (!this.datetimedate[id] || !valueRecord.minValue) {
          return undefined;
        }
        if (this.datetimedate[id].toDateString() === valueRecord.minValue.toDateString()) {
          const tempMin = this.getDateTime(valueRecord.value, valueRecord.minValue);
          return tempMin;
        }
        return undefined;
    }
  }

  checkAllDatetimes() {
    for (let i = 0; i < this.selectedTags.length; i++) {
      const selectedTag = this.selectedTags[i];
      if (selectedTag.dataType === 'Datetime' && !selectedTag.freeform) {
        if (!this.datetimeValidCheck(selectedTag.id)) {
          return false;
        }
      }
    }
    return true;
  }

  generateTooltip(tag) {
    return this.tagsService.generateTooltip(tag);
  }

  cancelClicked() {
    this.addToDataLayer([
      'singleAssetUpdateCancelClicked',
      { id: this.asset.id, name: this.asset.name },
    ]);
    if (this.onCancel) {
      this.onCancel();
    }
  }

  saveClicked() {
    this.detailForm.$submitted = true;
    if (this.sending || this.detailForm.$invalid || !this.checkAllDatetimes()) {
      return;
    }

    this.addToDataLayer([
      'singleAssetUpdateSaveClicked',
      { id: this.asset.id, name: this.asset.name },
    ]);

    this.sending = true;
    this.errorFlag = false;
    this.submitTags = [];
    this.equipToSubmit = cloneDeep(this.asset);
    this.equipToSubmit.attrs = {};
    this.equipToSubmit.name = this.assetName;
    for (const key in this.parsedAttrs) {
      this.equipToSubmit.attrs[key] = this.parsedAttrs[key];
    }
    for (const k in this.protectedAttrs) {
      this.equipToSubmit.attrs[k] = this.protectedAttrs[k];
    }
    for (let i = 0; i < this.selectedTags.length; i++) {
      const selectedTag = this.selectedTags[i];
      const valueRecord = this.values[selectedTag.id];
      const tVal = valueRecord.value || null;
      if (tVal === null) continue;
      const toAdd = {
        key: selectedTag.key,
      };
      switch (selectedTag.dataType) {
        case 'Text':
        case 'Hyperlink':
        case 'Integer':
        case 'Decimal':
          toAdd.v = valueRecord.value;
          break;
        case 'Date':
          toAdd.v = this.$filter('date')(valueRecord.value, 'yyyy-MM-dd');
          break;
        case 'Datetime':
          if (typeof valueRecord.value === 'string') {
            toAdd.v = valueRecord.value;
          } else {
            let temp = this.getDateTime(this.datetimedate[selectedTag.id], valueRecord.value);
            toAdd.v = temp;
          }
          break;
      }
      this.equipToSubmit.attrs[toAdd.key] = toAdd.v;
    }
    this.EquipmentService.putEquipment(this.equipToSubmit).then(
      (response) => {
        this.asset = response.data;
        this.isEditing = false;
        this.sending = false;
        this.refreshDetails();
        if (this.onUpdated) {
          this.onUpdated();
        }
      },
      (error) => {
        let errorMsg = this.gettextCatalog.getString('An error occurred while updating the asset');
        this.errorFlag = true;
        this.errorText = errorMsg;
        this.sending = false;
      },
    );
  }

  refreshDetails() {
    this.refresh();
  }

  addToDataLayer(gtmData) {
    const [event, data] = gtmData || [];
    window.dataLayer.push({
      event,
      data,
    });
  }
}

export default {
  template,
  controller: EquipmentUpdateController,
  controllerAs: 'vm',
  bindings: {
    asset: '<',
    onCancel: '&',
    onUpdated: '&',
  },
};
